<template>
  <div class="block">
    <button class="w-full hover:bg-gray-50" @click="click">
      <div class="flex items-center px-2 py-2 sm:px-6">
        <div class="min-w-0 flex-1 flex items-center">
          <div class="flex-shrink-0">
            <slot name="title" />
          </div>
        </div>
        <div>
          <slot name="icon" />
        </div>
      </div>

    </button>
  </div>
</template>

<script setup>
const emits = defineEmits(['click']);
const click = () => emits('click');
</script>

<style scoped>
</style>
